var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"visible":_vm.visible,"size":'85%',"destroy-on-close":true,"custom-class":'el-drawer-request-block',"with-header":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"p-4",staticStyle:{"background-color":"#F6F9FC"}},[_c('RequestBlock',{attrs:{"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }